import { gql } from "@apollo/client";

const PAYMENT_LINK_FIELDS = `
  id
  slug
  url
  name
  description
  amountMode
  amount
  minAmount
  maxAmount
  presetAmounts
  currency
  linkType
  interval
  maxPayments
  statementDescriptor
  status
  inactiveMessage
  expiresAt
  endsAt
  feeCover {
    enabled
  }
  tip {
    enabled
    presetPercentages
  }
  cashDiscount {
    enabled
    paymentMethodTypes
  }
  successBehavior {
    type
    message
    redirectUrl
  }
  metadata {
    key
    value
  }
  stats {
    views
    checkoutsStarted
    sales
    revenue
    refunded
    netCollected
    platformFees
  }
  createdAt
  updatedAt
`;

export const GET_PAYMENT_LINKS = gql`
  query paymentLinks(
    $status: [PaymentLinkStatusEnum]
    $first: Int
    $after: String
    $searchTerm: String
    $sortDirection: SortDirectionEnum
  ) {
    paymentLinks(
      status: $status
      first: $first
      after: $after
      searchTerm: $searchTerm
      sortDirection: $sortDirection
    ) {
      edges {
        cursor
        node {
          ${PAYMENT_LINK_FIELDS}
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`;

export const GET_PAYMENT_LINK = gql`
  query paymentLink($id: ID!) {
    paymentLink(id: $id) {
      ${PAYMENT_LINK_FIELDS}
      createdBy {
        id
        firstName
        lastName
      }
    }
  }
`;

export const GET_PAYMENT_LINK_PAYMENTS = gql`
  query paymentLinkPayments(
    $paymentLinkId: ID
    $status: [PaymentLinkPaymentStatusEnum]
    $first: Int
    $after: String
    $searchTerm: String
    $sortDirection: SortDirectionEnum
  ) {
    paymentLinkPayments(
      paymentLinkId: $paymentLinkId
      status: $status
      first: $first
      after: $after
      searchTerm: $searchTerm
      sortDirection: $sortDirection
    ) {
      edges {
        cursor
        node {
          id
          paymentLinkId
          status
          payerEmail
          payerName
          paymentMethodType
          paymentMethodBrand
          paymentMethodLast4
          intendedAmount
          feeCoverAmount
          tipAmount
          discountAmount
          totalCharged
          refundedAmount
          feeCoverAccepted
          clientReferenceId
          currency
          transactionId
          paymentError {
            code
            message
          }
          contact {
            id
            firstName
            lastName
            businessName
          }
          createdAt
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`;

export const CREATE_PAYMENT_LINK = gql`
  mutation createPaymentLink($input: AddPaymentLinkInput!) {
    createPaymentLink(input: $input) {
      ${PAYMENT_LINK_FIELDS}
    }
  }
`;

export const UPDATE_PAYMENT_LINK = gql`
  mutation updatePaymentLink($id: ID!, $input: UpdatePaymentLinkInput!) {
    updatePaymentLink(id: $id, input: $input) {
      ${PAYMENT_LINK_FIELDS}
    }
  }
`;

export const DEACTIVATE_PAYMENT_LINK = gql`
  mutation deactivatePaymentLink($id: ID!, $inactiveMessage: String) {
    deactivatePaymentLink(id: $id, inactiveMessage: $inactiveMessage) {
      id
      status
      inactiveMessage
    }
  }
`;

export const REACTIVATE_PAYMENT_LINK = gql`
  mutation reactivatePaymentLink($id: ID!) {
    reactivatePaymentLink(id: $id) {
      id
      status
    }
  }
`;
